import React from "react";

function DummyPage() {
  return <div>DummyPage</div>;
}

export default DummyPage;
